"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ctripCityMaping = [{
  "aa_location_id": "553248635976431790",
  "city_name": "Chongyi",
  "ctrip_id": "21238"
}, {
  "aa_location_id": "553248635976381352",
  "city_name": "Shanghai",
  "ctrip_id": "2"
}, {
  "aa_location_id": "553248635976385915",
  "city_name": "Yulong",
  "ctrip_id": "21360"
}, {
  "aa_location_id": "553248635976006218",
  "city_name": "Donggang",
  "ctrip_id": "7579"
}, {
  "aa_location_id": "553248635976006241",
  "city_name": "Huadian",
  "ctrip_id": "7814"
}, {
  "aa_location_id": "553248635976006037",
  "city_name": "Fuyu",
  "ctrip_id": "962"
}, {
  "aa_location_id": "553248635976005938",
  "city_name": "Fengcheng",
  "ctrip_id": "1003"
}, {
  "aa_location_id": "553248635975875715",
  "city_name": "Yongsheng",
  "ctrip_id": "2788"
}, {
  "aa_location_id": "553248635975875754",
  "city_name": "Jintang",
  "ctrip_id": "2553"
}, {
  "aa_location_id": "553248635975876201",
  "city_name": "Sanjiang",
  "ctrip_id": "7773"
}, {
  "aa_location_id": "553248635975875522",
  "city_name": "Dongxing",
  "ctrip_id": "3967"
}, {
  "aa_location_id": "553248635975875582",
  "city_name": "Huixian",
  "ctrip_id": "21773"
}, {
  "aa_location_id": "553248635975875562",
  "city_name": "Jingyuan",
  "ctrip_id": "1675"
}, {
  "aa_location_id": "553248635975875987",
  "city_name": "Shiyan",
  "ctrip_id": "452"
}, {
  "aa_location_id": "553248635975875410",
  "city_name": "Hekou",
  "ctrip_id": "1495"
}, {
  "aa_location_id": "553248635975875919",
  "city_name": "Jinjiang",
  "ctrip_id": "1803"
}, {
  "aa_location_id": "553248635975875912",
  "city_name": "Zhongfang",
  "ctrip_id": "2348"
}, {
  "aa_location_id": "553248635975876425",
  "city_name": "Jincheng",
  "ctrip_id": "1092"
}, {
  "aa_location_id": "553248635975875355",
  "city_name": "Liucheng",
  "ctrip_id": "21479"
}, {
  "aa_location_id": "553248635975875847",
  "city_name": "Datong",
  "ctrip_id": "136"
}, {
  "aa_location_id": "553248635975876411",
  "city_name": "Tonghua",
  "ctrip_id": "456"
}, {
  "aa_location_id": "553248635975875293",
  "city_name": "Fengshun",
  "ctrip_id": "955"
}, {
  "aa_location_id": "553248635975874752",
  "city_name": "Fushun",
  "ctrip_id": "252"
}, {
  "aa_location_id": "553248635975872712",
  "city_name": "Wulan",
  "ctrip_id": "2541"
}, {
  "aa_location_id": "553248635975875311",
  "city_name": "Nanyue",
  "ctrip_id": "21282"
}, {
  "aa_location_id": "553248635975875207",
  "city_name": "Zhenghe",
  "ctrip_id": "21746"
}, {
  "aa_location_id": "553248635975874723",
  "city_name": "Lingyun",
  "ctrip_id": "21471"
}, {
  "aa_location_id": "553248635975875246",
  "city_name": "Weiyuan",
  "ctrip_id": "21077"
}, {
  "aa_location_id": "553248635975873622",
  "city_name": "Yanhe",
  "ctrip_id": "21053"
}, {
  "aa_location_id": "553248635975873638",
  "city_name": "Longquan",
  "ctrip_id": "3055"
}, {
  "aa_location_id": "553248635975872396",
  "city_name": "Chongyang",
  "ctrip_id": "21512"
}, {
  "aa_location_id": "553248635975871885",
  "city_name": "Xinle",
  "ctrip_id": "1991"
}, {
  "aa_location_id": "553248635975871924",
  "city_name": "Dongan",
  "ctrip_id": "990"
}, {
  "aa_location_id": "553248635975873449",
  "city_name": "Zhangzi",
  "ctrip_id": "21083"
}, {
  "aa_location_id": "553248635975874884",
  "city_name": "Jiuzhi",
  "ctrip_id": "21225"
}, {
  "aa_location_id": "553248635975874412",
  "city_name": "Taibai",
  "ctrip_id": "21821"
}, {
  "aa_location_id": "553248635975874332",
  "city_name": "Sanhe",
  "ctrip_id": "1632"
}, {
  "aa_location_id": "553248635975874861",
  "city_name": "Xintian",
  "ctrip_id": "21817"
}, {
  "aa_location_id": "553248635975871206",
  "city_name": "Xingtai",
  "ctrip_id": "947"
}, {
  "aa_location_id": "553248635975868652",
  "city_name": "Baishan",
  "ctrip_id": "3886"
}, {
  "aa_location_id": "553248635975870643",
  "city_name": "Menglian",
  "ctrip_id": "21604"
}, {
  "aa_location_id": "553248635975866897",
  "city_name": "Ganquan",
  "ctrip_id": "1941"
}, {
  "aa_location_id": "553248635975871535",
  "city_name": "Yanshan",
  "ctrip_id": "7733"
}, {
  "aa_location_id": "553248635975869993",
  "city_name": "Zhuolu",
  "ctrip_id": "21757"
}, {
  "aa_location_id": "553248635975866820",
  "city_name": "Luocheng",
  "ctrip_id": "21618"
}, {
  "aa_location_id": "553248635975870924",
  "city_name": "Chengjiang",
  "ctrip_id": "20919"
}, {
  "aa_location_id": "553248635975868902",
  "city_name": "Mengshan",
  "ctrip_id": "21591"
}, {
  "aa_location_id": "553248635975867799",
  "city_name": "Xingguo",
  "ctrip_id": "934"
}, {
  "aa_location_id": "553248635975871413",
  "city_name": "Nanping",
  "ctrip_id": "606"
}, {
  "aa_location_id": "553248635975865787",
  "city_name": "Liuhe",
  "ctrip_id": "2853"
}, {
  "aa_location_id": "553248635975865272",
  "city_name": "Longxi",
  "ctrip_id": "968"
}, {
  "aa_location_id": "553248635975870803",
  "city_name": "Nantou",
  "ctrip_id": "7524"
}, {
  "aa_location_id": "553248635975869777",
  "city_name": "Luohe",
  "ctrip_id": "1088"
}, {
  "aa_location_id": "553248635975870296",
  "city_name": "Heshan",
  "ctrip_id": "291"
}, {
  "aa_location_id": "553248635975867253",
  "city_name": "Xinyang",
  "ctrip_id": "510"
}, {
  "aa_location_id": "553248635975871333",
  "city_name": "Xiping",
  "ctrip_id": "21159"
}, {
  "aa_location_id": "553248635975869283",
  "city_name": "Boye",
  "ctrip_id": "20875"
}, {
  "aa_location_id": "553248635975866636",
  "city_name": "Shanyang",
  "ctrip_id": "21730"
}, {
  "aa_location_id": "553248635975869233",
  "city_name": "Xinhe",
  "ctrip_id": "2226"
}, {
  "aa_location_id": "553248635975867680",
  "city_name": "Wanzai",
  "ctrip_id": "21123"
}, {
  "aa_location_id": "553248635975863516",
  "city_name": "Maqu",
  "ctrip_id": "21626"
}, {
  "aa_location_id": "553248635975856323",
  "city_name": "Jilong",
  "ctrip_id": "7810"
}, {
  "aa_location_id": "553248635975861448",
  "city_name": "Changning",
  "ctrip_id": "20967"
}, {
  "aa_location_id": "553248635975864468",
  "city_name": "Wuqiao",
  "ctrip_id": "887"
}, {
  "aa_location_id": "553248635975862430",
  "city_name": "Jinghe",
  "ctrip_id": "2547"
}, {
  "aa_location_id": "553248635975861903",
  "city_name": "Gucheng",
  "ctrip_id": "2157"
}, {
  "aa_location_id": "553248635975854197",
  "city_name": "Lingchuan",
  "ctrip_id": "2376"
}, {
  "aa_location_id": "553248635975854134",
  "city_name": "Qingyun",
  "ctrip_id": "19954"
}, {
  "aa_location_id": "553248635975854655",
  "city_name": "Qingjian",
  "ctrip_id": "1159"
}, {
  "aa_location_id": "553248635975857124",
  "city_name": "Baisha",
  "ctrip_id": "21025"
}, {
  "aa_location_id": "553248635975859073",
  "city_name": "Yongning",
  "ctrip_id": "2867"
}, {
  "aa_location_id": "553248635975862666",
  "city_name": "Xunhua",
  "ctrip_id": "21101"
}, {
  "aa_location_id": "553248635975864149",
  "city_name": "Meishan",
  "ctrip_id": "1148"
}, {
  "aa_location_id": "553248635975862110",
  "city_name": "Lixin",
  "ctrip_id": "21157"
}, {
  "aa_location_id": "553248635975863642",
  "city_name": "Dongfeng",
  "ctrip_id": "21233"
}, {
  "aa_location_id": "553248635975854363",
  "city_name": "Donghai",
  "ctrip_id": "894"
}, {
  "aa_location_id": "553248635975860484",
  "city_name": "Lianhua",
  "ctrip_id": "21573"
}, {
  "aa_location_id": "553248635975859983",
  "city_name": "Weinan",
  "ctrip_id": "1030"
}, {
  "aa_location_id": "553248635975855906",
  "city_name": "Anfu",
  "ctrip_id": "20915"
}, {
  "aa_location_id": "553248635975863087",
  "city_name": "Xinglong",
  "ctrip_id": "499"
}, {
  "aa_location_id": "553248635975858474",
  "city_name": "Xinglong",
  "ctrip_id": "499"
}, {
  "aa_location_id": "553248635975851713",
  "city_name": "Zhongba",
  "ctrip_id": "21149"
}, {
  "aa_location_id": "553248635975847664",
  "city_name": "Xinxing",
  "ctrip_id": "2403"
}, {
  "aa_location_id": "553248635975850217",
  "city_name": "Tumen",
  "ctrip_id": "463"
}, {
  "aa_location_id": "553248635975853710",
  "city_name": "Daying",
  "ctrip_id": "2552"
}, {
  "aa_location_id": "553248635975850632",
  "city_name": "Longmen",
  "ctrip_id": "21075"
}, {
  "aa_location_id": "553248635975850665",
  "city_name": "Yonghe",
  "ctrip_id": "2351"
}, {
  "aa_location_id": "553248635975848551",
  "city_name": "Ziyun",
  "ctrip_id": "7542"
}, {
  "aa_location_id": "553248635975847429",
  "city_name": "Gucheng",
  "ctrip_id": "2157"
}, {
  "aa_location_id": "553248635975848972",
  "city_name": "Lianhua",
  "ctrip_id": "21573"
}, {
  "aa_location_id": "553248635975852083",
  "city_name": "Wangmo",
  "ctrip_id": "21539"
}, {
  "aa_location_id": "553248635975852584",
  "city_name": "Xiangyang",
  "ctrip_id": "496"
}, {
  "aa_location_id": "553248635975847382",
  "city_name": "Pingnan",
  "ctrip_id": "7538"
}, {
  "aa_location_id": "553248635975847922",
  "city_name": "Yuexi",
  "ctrip_id": "21453"
}, {
  "aa_location_id": "553248635975847747",
  "city_name": "Dongping",
  "ctrip_id": "7728"
}, {
  "aa_location_id": "553248635975851338",
  "city_name": "Xinping",
  "ctrip_id": "21407"
}, {
  "aa_location_id": "553248635975849222",
  "city_name": "Xiangshui",
  "ctrip_id": "7695"
}, {
  "aa_location_id": "553248635975849229",
  "city_name": "Fengcheng",
  "ctrip_id": "1003"
}, {
  "aa_location_id": "553248635975849257",
  "city_name": "Zhongshan",
  "ctrip_id": "553"
}, {
  "aa_location_id": "553248635823529355",
  "city_name": "Shannan",
  "ctrip_id": "439"
}, {
  "aa_location_id": "553248635921598975",
  "city_name": "Guzhen",
  "ctrip_id": "891"
}, {
  "aa_location_id": "553248635823563561",
  "city_name": "Yutian",
  "ctrip_id": "1633"
}, {
  "aa_location_id": "553248635823563532",
  "city_name": "Shanshan",
  "ctrip_id": "901"
}, {
  "aa_location_id": "553248635823563537",
  "city_name": "Emin",
  "ctrip_id": "21165"
}, {
  "aa_location_id": "553248635823528806",
  "city_name": "Wuzhong",
  "ctrip_id": "7587"
}, {
  "aa_location_id": "553248635823528261",
  "city_name": "Fuzhou",
  "ctrip_id": "258"
}, {
  "aa_location_id": "553248635823563598",
  "city_name": "Moyu",
  "ctrip_id": "21763"
}, {
  "aa_location_id": "553248635823530720",
  "city_name": "Guang'an",
  "ctrip_id": "1100"
}, {
  "aa_location_id": "553248635823563519",
  "city_name": "Gongliu",
  "ctrip_id": "20911"
}, {
  "aa_location_id": "553248635823531201",
  "city_name": "Yanbian",
  "ctrip_id": "20903"
}, {
  "aa_location_id": "553248635823563971",
  "city_name": "Hejing",
  "ctrip_id": "2211"
}, {
  "aa_location_id": "553248635823525071",
  "city_name": "Qianjiang",
  "ctrip_id": "4154"
}, {
  "aa_location_id": "553248635939576598",
  "city_name": "Huangling",
  "ctrip_id": "127"
}, {
  "aa_location_id": "553248635823563803",
  "city_name": "Bohu",
  "ctrip_id": "21780"
}, {
  "aa_location_id": "553248635823525463",
  "city_name": "Shuangyashan",
  "ctrip_id": "1617"
}, {
  "aa_location_id": "3000744653",
  "city_name": "Shannan",
  "ctrip_id": "439"
}, {
  "aa_location_id": "3000721638",
  "city_name": "Maduo",
  "ctrip_id": "21136"
}, {
  "aa_location_id": "3000720334",
  "city_name": "Zhenglanqi",
  "ctrip_id": "21373"
}, {
  "aa_location_id": "3000720280",
  "city_name": "Xianghuangqi",
  "ctrip_id": "21775"
}, {
  "aa_location_id": "3000717744",
  "city_name": "Miaoli",
  "ctrip_id": "7809"
}, {
  "aa_location_id": "3000477889",
  "city_name": "Gejiu",
  "ctrip_id": "3922"
}, {
  "aa_location_id": "3000462486",
  "city_name": "Ruili",
  "ctrip_id": "412"
}, {
  "aa_location_id": "3000428166",
  "city_name": "Danjiangkou",
  "ctrip_id": "7685"
}, {
  "aa_location_id": "3000462478",
  "city_name": "Mao County",
  "ctrip_id": "10298"
}, {
  "aa_location_id": "3000474716",
  "city_name": "Haidong",
  "ctrip_id": "7752"
}, {
  "aa_location_id": "3000422875",
  "city_name": "Zhucheng",
  "ctrip_id": "4144"
}, {
  "aa_location_id": "3000392563",
  "city_name": "Lin County",
  "ctrip_id": "21467"
}, {
  "aa_location_id": "3000663926",
  "city_name": "Huayuan",
  "ctrip_id": "20958"
}, {
  "aa_location_id": "3000391836",
  "city_name": "Tongzi County",
  "ctrip_id": "983"
}, {
  "aa_location_id": "3000391867",
  "city_name": "Teng County",
  "ctrip_id": "21095"
}, {
  "aa_location_id": "3000391763",
  "city_name": "Anda",
  "ctrip_id": "1130"
}, {
  "aa_location_id": "3000390098",
  "city_name": "Qian County",
  "ctrip_id": "21703"
}, {
  "aa_location_id": "3000390054",
  "city_name": "Jing County",
  "ctrip_id": "21004"
}, {
  "aa_location_id": "3000385651",
  "city_name": "Xia County",
  "ctrip_id": "20902"
}, {
  "aa_location_id": "3000386169",
  "city_name": "Ci County",
  "ctrip_id": "21707"
}, {
  "aa_location_id": "3000385052",
  "city_name": "Hekou",
  "ctrip_id": "1495"
}, {
  "aa_location_id": "3000384524",
  "city_name": "Cao County",
  "ctrip_id": "1696"
}, {
  "aa_location_id": "3000387622",
  "city_name": "Hua County",
  "ctrip_id": "21795"
}, {
  "aa_location_id": "3000389588",
  "city_name": "Jingxing County",
  "ctrip_id": "21769"
}, {
  "aa_location_id": "3000387549",
  "city_name": "Ying County",
  "ctrip_id": "21041"
}, {
  "aa_location_id": "3000382656",
  "city_name": "Ju County",
  "ctrip_id": "10273"
}, {
  "aa_location_id": "3000382610",
  "city_name": "Song County",
  "ctrip_id": "20812"
}, {
  "aa_location_id": "3000382600",
  "city_name": "Xiao County",
  "ctrip_id": "21428"
}, {
  "aa_location_id": "3000381532",
  "city_name": "Rongjiang",
  "ctrip_id": "21080"
}, {
  "aa_location_id": "3000382588",
  "city_name": "You County",
  "ctrip_id": "21274"
}, {
  "aa_location_id": "3000381402",
  "city_name": "Guan County",
  "ctrip_id": "21343"
}, {
  "aa_location_id": "3000381389",
  "city_name": "Qianwei County",
  "ctrip_id": "21293"
}, {
  "aa_location_id": "3000384510",
  "city_name": "Sha County",
  "ctrip_id": "449"
}, {
  "aa_location_id": "3000381435",
  "city_name": "She County",
  "ctrip_id": "508"
}, {
  "aa_location_id": "3000383971",
  "city_name": "Gong County",
  "ctrip_id": "21544"
}, {
  "aa_location_id": "3000381351",
  "city_name": "Xiong County",
  "ctrip_id": "21060"
}, {
  "aa_location_id": "3000382836",
  "city_name": "Qing County",
  "ctrip_id": "502"
}, {
  "aa_location_id": "3000383334",
  "city_name": "Shanghang",
  "ctrip_id": "3962"
}, {
  "aa_location_id": "3000380269",
  "city_name": "Bin County",
  "ctrip_id": "3944"
}, {
  "aa_location_id": "3000380733",
  "city_name": "Tang County",
  "ctrip_id": "21258"
}, {
  "aa_location_id": "3000380729",
  "city_name": "Yi County",
  "ctrip_id": "403"
}, {
  "aa_location_id": "3000376052",
  "city_name": "Mengzi",
  "ctrip_id": "2431"
}, {
  "aa_location_id": "3000366263",
  "city_name": "Bazhong",
  "ctrip_id": "3966"
}, {
  "aa_location_id": "3000375382",
  "city_name": "Wusu",
  "ctrip_id": "2546"
}, {
  "aa_location_id": "3000375383",
  "city_name": "Atushi",
  "ctrip_id": "2229"
}, {
  "aa_location_id": "3000375366",
  "city_name": "Yumen",
  "ctrip_id": "1326"
}, {
  "aa_location_id": "3000375367",
  "city_name": "Hezuo",
  "ctrip_id": "21654"
}, {
  "aa_location_id": "3000375363",
  "city_name": "Xingping",
  "ctrip_id": "1022"
}, {
  "aa_location_id": "3000005705",
  "city_name": "Anping",
  "ctrip_id": "1575"
}, {
  "aa_location_id": "3000375373",
  "city_name": "Fukang",
  "ctrip_id": "21249"
}, {
  "aa_location_id": "3000375368",
  "city_name": "Qingtongxia",
  "ctrip_id": "1034"
}, {
  "aa_location_id": "3000375369",
  "city_name": "Anning",
  "ctrip_id": "10254"
}, {
  "aa_location_id": "3000375318",
  "city_name": "Gaozhou",
  "ctrip_id": "686"
}, {
  "aa_location_id": "3000375316",
  "city_name": "Enping",
  "ctrip_id": "1428"
}, {
  "aa_location_id": "3000375326",
  "city_name": "Yingde",
  "ctrip_id": "884"
}, {
  "aa_location_id": "3000375327",
  "city_name": "Xingning",
  "ctrip_id": "954"
}, {
  "aa_location_id": "3000375323",
  "city_name": "Lufeng",
  "ctrip_id": "4145"
}, {
  "aa_location_id": "3000375320",
  "city_name": "Wuchuan",
  "ctrip_id": "7606"
}, {
  "aa_location_id": "3000375302",
  "city_name": "Zixing",
  "ctrip_id": "3977"
}, {
  "aa_location_id": "3000375303",
  "city_name": "Lengshuijiang",
  "ctrip_id": "920"
}, {
  "aa_location_id": "3000367111",
  "city_name": "Xiantao",
  "ctrip_id": "1882"
}, {
  "aa_location_id": "3000375300",
  "city_name": "Yuanjiang",
  "ctrip_id": "21357"
}, {
  "aa_location_id": "3000375298",
  "city_name": "Linxiang",
  "ctrip_id": "21219"
}, {
  "aa_location_id": "3000375299",
  "city_name": "Jinshi",
  "ctrip_id": "21466"
}, {
  "aa_location_id": "3000367628",
  "city_name": "Renqiu",
  "ctrip_id": "1069"
}, {
  "aa_location_id": "3000375308",
  "city_name": "Lechang",
  "ctrip_id": "938"
}, {
  "aa_location_id": "3000375309",
  "city_name": "Nanxiong",
  "ctrip_id": "21670"
}, {
  "aa_location_id": "3000367627",
  "city_name": "Erenhot",
  "ctrip_id": "7626"
}, {
  "aa_location_id": "3000375304",
  "city_name": "Lianyuan",
  "ctrip_id": "2248"
}, {
  "aa_location_id": "3000375305",
  "city_name": "Hongjiang",
  "ctrip_id": "7803"
}, {
  "aa_location_id": "3000005685",
  "city_name": "Batang",
  "ctrip_id": "21557"
}, {
  "aa_location_id": "3000375344",
  "city_name": "Qionglai",
  "ctrip_id": "7553"
}, {
  "aa_location_id": "3000375358",
  "city_name": "Jiangyou",
  "ctrip_id": "1054"
}, {
  "aa_location_id": "3000375356",
  "city_name": "Xuanwei",
  "ctrip_id": "984"
}, {
  "aa_location_id": "3000375354",
  "city_name": "Renhuai",
  "ctrip_id": "7619"
}, {
  "aa_location_id": "3000375355",
  "city_name": "Fuquan",
  "ctrip_id": "2487"
}, {
  "aa_location_id": "3000375352",
  "city_name": "Wanyuan",
  "ctrip_id": "1099"
}, {
  "aa_location_id": "3000375334",
  "city_name": "Lianzhou",
  "ctrip_id": "3931"
}, {
  "aa_location_id": "3000005665",
  "city_name": "Botou",
  "ctrip_id": "7629"
}, {
  "aa_location_id": "3000375332",
  "city_name": "Dongxing",
  "ctrip_id": "3967"
}, {
  "aa_location_id": "3000005668",
  "city_name": "Binhai",
  "ctrip_id": "20916"
}, {
  "aa_location_id": "3000375331",
  "city_name": "Cenxi",
  "ctrip_id": "21296"
}, {
  "aa_location_id": "3000375329",
  "city_name": "Yangchun",
  "ctrip_id": "1103"
}, {
  "aa_location_id": "3000375342",
  "city_name": "Pengzhou",
  "ctrip_id": "7550"
}, {
  "aa_location_id": "3000375343",
  "city_name": "Shifang",
  "ctrip_id": "21564"
}, {
  "aa_location_id": "3000375340",
  "city_name": "Guiping",
  "ctrip_id": "3968"
}, {
  "aa_location_id": "3000375339",
  "city_name": "Guanghan",
  "ctrip_id": "750"
}, {
  "aa_location_id": "3000375254",
  "city_name": "Xingyang",
  "ctrip_id": "969"
}, {
  "aa_location_id": "3000375255",
  "city_name": "Wugang",
  "ctrip_id": "3995"
}, {
  "aa_location_id": "3000375252",
  "city_name": "Rushan",
  "ctrip_id": "7554"
}, {
  "aa_location_id": "3000375253",
  "city_name": "Leling",
  "ctrip_id": "7783"
}, {
  "aa_location_id": "3000375250",
  "city_name": "Gongyi",
  "ctrip_id": "958"
}, {
  "aa_location_id": "3000375248",
  "city_name": "Rongcheng",
  "ctrip_id": "833"
}, {
  "aa_location_id": "3000375262",
  "city_name": "Weihui",
  "ctrip_id": "21143"
}, {
  "aa_location_id": "3000375263",
  "city_name": "Qinyang",
  "ctrip_id": "2063"
}, {
  "aa_location_id": "3000375260",
  "city_name": "Huixian",
  "ctrip_id": "21773"
}, {
  "aa_location_id": "3000375259",
  "city_name": "Linzhou",
  "ctrip_id": "7545"
}, {
  "aa_location_id": "3000375256",
  "city_name": "Yanshi",
  "ctrip_id": "957"
}, {
  "aa_location_id": "3000375257",
  "city_name": "Xinzheng",
  "ctrip_id": "21009"
}, {
  "aa_location_id": "3000375238",
  "city_name": "Anqiu",
  "ctrip_id": "7736"
}, {
  "aa_location_id": "3000375234",
  "city_name": "Laizhou",
  "ctrip_id": "3915"
}, {
  "aa_location_id": "3000375232",
  "city_name": "Tengzhou",
  "ctrip_id": "909"
}, {
  "aa_location_id": "3000374721",
  "city_name": "Tacheng",
  "ctrip_id": "455"
}, {
  "aa_location_id": "3000375246",
  "city_name": "Xintai",
  "ctrip_id": "7771"
}, {
  "aa_location_id": "3000375242",
  "city_name": "Feicheng",
  "ctrip_id": "1884"
}, {
  "aa_location_id": "3000375240",
  "city_name": "Changyi",
  "ctrip_id": "21660"
}, {
  "aa_location_id": "3000375286",
  "city_name": "Honghu",
  "ctrip_id": "7618"
}, {
  "aa_location_id": "3000375287",
  "city_name": "Lichuan",
  "ctrip_id": "7779"
}, {
  "aa_location_id": "3000375282",
  "city_name": "Hanchuan",
  "ctrip_id": "21061"
}, {
  "aa_location_id": "3000375283",
  "city_name": "Guangshui",
  "ctrip_id": "21818"
}, {
  "aa_location_id": "3000375281",
  "city_name": "Shishou",
  "ctrip_id": "21442"
}, {
  "aa_location_id": "3000375295",
  "city_name": "Xiangxiang",
  "ctrip_id": "917"
}, {
  "aa_location_id": "3000375292",
  "city_name": "Tianmen",
  "ctrip_id": "3920"
}, {
  "aa_location_id": "3000375291",
  "city_name": "Liling",
  "ctrip_id": "981"
}, {
  "aa_location_id": "3000375288",
  "city_name": "Songzi",
  "ctrip_id": "1558"
}, {
  "aa_location_id": "3000375270",
  "city_name": "Dengzhou",
  "ctrip_id": "1058"
}, {
  "aa_location_id": "3000375271",
  "city_name": "Daye",
  "ctrip_id": "3914"
}, {
  "aa_location_id": "3000375268",
  "city_name": "Mengzhou",
  "ctrip_id": "21699"
}, {
  "aa_location_id": "3000375269",
  "city_name": "Yima",
  "ctrip_id": "1029"
}, {
  "aa_location_id": "3000375267",
  "city_name": "Changge",
  "ctrip_id": "7650"
}, {
  "aa_location_id": "3000375265",
  "city_name": "Lingbao",
  "ctrip_id": "1023"
}, {
  "aa_location_id": "3000375279",
  "city_name": "Anlu",
  "ctrip_id": "1556"
}, {
  "aa_location_id": "3000375276",
  "city_name": "Zaoyang",
  "ctrip_id": "1555"
}, {
  "aa_location_id": "3000375277",
  "city_name": "Zhijiang",
  "ctrip_id": "1557"
}, {
  "aa_location_id": "3000375274",
  "city_name": "Dangyang",
  "ctrip_id": "1122"
}, {
  "aa_location_id": "3000375272",
  "city_name": "Yongcheng",
  "ctrip_id": "4020"
}, {
  "aa_location_id": "3000375199",
  "city_name": "Longquan",
  "ctrip_id": "3055"
}, {
  "aa_location_id": "3000375197",
  "city_name": "Tongcheng",
  "ctrip_id": "944"
}, {
  "aa_location_id": "3000375173",
  "city_name": "Hailun",
  "ctrip_id": "1682"
}, {
  "aa_location_id": "3000375170",
  "city_name": "Pizhou",
  "ctrip_id": "3929"
}, {
  "aa_location_id": "3000375168",
  "city_name": "Bei'an",
  "ctrip_id": "153"
}, {
  "aa_location_id": "3000375181",
  "city_name": "Zhaodong",
  "ctrip_id": "1624"
}, {
  "aa_location_id": "3000375176",
  "city_name": "Gaoyou",
  "ctrip_id": "4125"
}, {
  "aa_location_id": "3000375223",
  "city_name": "Dexing",
  "ctrip_id": "3927"
}, {
  "aa_location_id": "3000374709",
  "city_name": "Macheng",
  "ctrip_id": "1079"
}, {
  "aa_location_id": "3000375218",
  "city_name": "Fengcheng",
  "ctrip_id": "1003"
}, {
  "aa_location_id": "3000375216",
  "city_name": "Guixi",
  "ctrip_id": "3919"
}, {
  "aa_location_id": "3000374718",
  "city_name": "Ruijin",
  "ctrip_id": "3971"
}, {
  "aa_location_id": "3000375230",
  "city_name": "Longkou",
  "ctrip_id": "3946"
}, {
  "aa_location_id": "3000375231",
  "city_name": "Laixi",
  "ctrip_id": "1804"
}, {
  "aa_location_id": "3000375226",
  "city_name": "Ruichang",
  "ctrip_id": "1700"
}, {
  "aa_location_id": "3000375204",
  "city_name": "Longhai",
  "ctrip_id": "341"
}, {
  "aa_location_id": "3000375201",
  "city_name": "Ningguo",
  "ctrip_id": "1005"
}, {
  "aa_location_id": "3000375212",
  "city_name": "Yong'an",
  "ctrip_id": "485"
}, {
  "aa_location_id": "3000375210",
  "city_name": "Zhangping",
  "ctrip_id": "600"
}, {
  "aa_location_id": "3000375211",
  "city_name": "Leping",
  "ctrip_id": "1089"
}, {
  "aa_location_id": "3000375208",
  "city_name": "Jian'ou",
  "ctrip_id": "3961"
}, {
  "aa_location_id": "3000375127",
  "city_name": "Diaobingshan",
  "ctrip_id": "20917"
}, {
  "aa_location_id": "3000375124",
  "city_name": "Linghai",
  "ctrip_id": "21234"
}, {
  "aa_location_id": "3000375125",
  "city_name": "Beizhen",
  "ctrip_id": "7698"
}, {
  "aa_location_id": "3000375135",
  "city_name": "Kaiyuan",
  "ctrip_id": "1333"
}, {
  "aa_location_id": "3000375132",
  "city_name": "Beipiao",
  "ctrip_id": "2415"
}, {
  "aa_location_id": "3000375130",
  "city_name": "Huolinguole",
  "ctrip_id": "21091"
}, {
  "aa_location_id": "3000375128",
  "city_name": "Dengta",
  "ctrip_id": "1641"
}, {
  "aa_location_id": "3000375111",
  "city_name": "Eerguna",
  "ctrip_id": "7638"
}, {
  "aa_location_id": "3000375104",
  "city_name": "Huozhou",
  "ctrip_id": "21212"
}, {
  "aa_location_id": "3000375105",
  "city_name": "Yuanping",
  "ctrip_id": "1511"
}, {
  "aa_location_id": "3000375117",
  "city_name": "Xinmin",
  "ctrip_id": "1638"
}, {
  "aa_location_id": "3000375112",
  "city_name": "Genhe",
  "ctrip_id": "2651"
}, {
  "aa_location_id": "3000375113",
  "city_name": "Aershan",
  "ctrip_id": "1658"
}, {
  "aa_location_id": "3000375158",
  "city_name": "Tongjiang",
  "ctrip_id": "21112"
}, {
  "aa_location_id": "3000375159",
  "city_name": "Hulin",
  "ctrip_id": "156"
}, {
  "aa_location_id": "3000375156",
  "city_name": "Tieli",
  "ctrip_id": "1618"
}, {
  "aa_location_id": "3000375157",
  "city_name": "Nehe",
  "ctrip_id": "1589"
}, {
  "aa_location_id": "3000375152",
  "city_name": "Hunchun",
  "ctrip_id": "4137"
}, {
  "aa_location_id": "3000375167",
  "city_name": "Muling",
  "ctrip_id": "1601"
}, {
  "aa_location_id": "3000375164",
  "city_name": "Fujin",
  "ctrip_id": "1622"
}, {
  "aa_location_id": "3000375165",
  "city_name": "Hailin",
  "ctrip_id": "1666"
}, {
  "aa_location_id": "3000375162",
  "city_name": "Mishan",
  "ctrip_id": "1609"
}, {
  "aa_location_id": "3000375143",
  "city_name": "Gongzhuling",
  "ctrip_id": "1046"
}, {
  "aa_location_id": "3000375140",
  "city_name": "Shulan",
  "ctrip_id": "1584"
}, {
  "aa_location_id": "3000375141",
  "city_name": "Panshi",
  "ctrip_id": "1654"
}, {
  "aa_location_id": "3000375139",
  "city_name": "Dehui",
  "ctrip_id": "1661"
}, {
  "aa_location_id": "3000375136",
  "city_name": "Jiaohe",
  "ctrip_id": "1585"
}, {
  "aa_location_id": "3000375150",
  "city_name": "Taonan",
  "ctrip_id": "1507"
}, {
  "aa_location_id": "3000375149",
  "city_name": "Tumen",
  "ctrip_id": "463"
}, {
  "aa_location_id": "3000375146",
  "city_name": "Shuangliao",
  "ctrip_id": "20882"
}, {
  "aa_location_id": "3000375145",
  "city_name": "Meihekou",
  "ctrip_id": "1115"
}, {
  "aa_location_id": "3000209674",
  "city_name": "Qiannan",
  "ctrip_id": "21179"
}, {
  "aa_location_id": "3000375094",
  "city_name": "Hejian",
  "ctrip_id": "7759"
}, {
  "aa_location_id": "3000375090",
  "city_name": "Zhuozhou",
  "ctrip_id": "7605"
}, {
  "aa_location_id": "3000375102",
  "city_name": "Gaoping",
  "ctrip_id": "2057"
}, {
  "aa_location_id": "3000375103",
  "city_name": "Houma",
  "ctrip_id": "1095"
}, {
  "aa_location_id": "3000375100",
  "city_name": "Hejin",
  "ctrip_id": "7772"
}, {
  "aa_location_id": "3000375098",
  "city_name": "Yongji",
  "ctrip_id": "1315"
}, {
  "aa_location_id": "3000375078",
  "city_name": "Xinji",
  "ctrip_id": "905"
}, {
  "aa_location_id": "3000375087",
  "city_name": "Wu'an",
  "ctrip_id": "2033"
}, {
  "aa_location_id": "3000375080",
  "city_name": "Xinle",
  "ctrip_id": "1991"
}, {
  "aa_location_id": "3000375081",
  "city_name": "Zunhua",
  "ctrip_id": "545"
}, {
  "aa_location_id": "3000005333",
  "city_name": "Leting",
  "ctrip_id": "7688"
}, {
  "aa_location_id": "3000004826",
  "city_name": "Zhaoyuan",
  "ctrip_id": "4251"
}, {
  "aa_location_id": "3000005339",
  "city_name": "Langzhong",
  "ctrip_id": "3275"
}, {
  "aa_location_id": "3000005343",
  "city_name": "Laiyang",
  "ctrip_id": "1038"
}, {
  "aa_location_id": "6338672",
  "city_name": "Guigang",
  "ctrip_id": "1518"
}, {
  "aa_location_id": "6338673",
  "city_name": "Qitaihe",
  "ctrip_id": "1599"
}, {
  "aa_location_id": "6338675",
  "city_name": "Xiaogan",
  "ctrip_id": "1490"
}, {
  "aa_location_id": "6338676",
  "city_name": "Liaoyuan",
  "ctrip_id": "352"
}, {
  "aa_location_id": "3000004804",
  "city_name": "Zhuanghe",
  "ctrip_id": "1646"
}, {
  "aa_location_id": "6345343",
  "city_name": "Dongfang",
  "ctrip_id": "48"
}, {
  "aa_location_id": "6340676",
  "city_name": "Burqin",
  "ctrip_id": "3327"
}, {
  "aa_location_id": "6352461",
  "city_name": "Qitaihe",
  "ctrip_id": "1599"
}, {
  "aa_location_id": "3000005345",
  "city_name": "Kuandian",
  "ctrip_id": "20853"
}, {
  "aa_location_id": "3000005349",
  "city_name": "Kaiyang",
  "ctrip_id": "20877"
}, {
  "aa_location_id": "3000005351",
  "city_name": "Juye",
  "ctrip_id": "21138"
}, {
  "aa_location_id": "3000004842",
  "city_name": "Zhangbei",
  "ctrip_id": "21790"
}, {
  "aa_location_id": "3000005356",
  "city_name": "Juancheng",
  "ctrip_id": "21399"
}, {
  "aa_location_id": "3000005265",
  "city_name": "Luoding",
  "ctrip_id": "339"
}, {
  "aa_location_id": "6338107",
  "city_name": "Baise",
  "ctrip_id": "1140"
}, {
  "aa_location_id": "3000004795",
  "city_name": "Zoucheng",
  "ctrip_id": "7519"
}, {
  "aa_location_id": "3000005287",
  "city_name": "Liuyang",
  "ctrip_id": "4185"
}, {
  "aa_location_id": "3000005206",
  "city_name": "Penglai",
  "ctrip_id": "310"
}, {
  "aa_location_id": "3000005190",
  "city_name": "Qian'an",
  "ctrip_id": "2230"
}, {
  "aa_location_id": "3000005195",
  "city_name": "Puning",
  "ctrip_id": "389"
}, {
  "aa_location_id": "3000005235",
  "city_name": "Mojiang",
  "ctrip_id": "21334"
}, {
  "aa_location_id": "3000005240",
  "city_name": "Mingguang",
  "ctrip_id": "892"
}, {
  "aa_location_id": "3000005230",
  "city_name": "Nan'an",
  "ctrip_id": "374"
}, {
  "aa_location_id": "3000005145",
  "city_name": "Sanjiang",
  "ctrip_id": "7773"
}, {
  "aa_location_id": "3000005635",
  "city_name": "Chongzhou",
  "ctrip_id": "7678"
}, {
  "aa_location_id": "6345346",
  "city_name": "Jiyuan",
  "ctrip_id": "1454"
}, {
  "aa_location_id": "3000005170",
  "city_name": "Qingzhen",
  "ctrip_id": "7642"
}, {
  "aa_location_id": "6345355",
  "city_name": "Baicheng",
  "ctrip_id": "1116"
}, {
  "aa_location_id": "6345356",
  "city_name": "Qiandongnan",
  "ctrip_id": "21778"
}, {
  "aa_location_id": "3000005158",
  "city_name": "Renhua",
  "ctrip_id": "20939"
}, {
  "aa_location_id": "3000005584",
  "city_name": "Dingbian",
  "ctrip_id": "21486"
}, {
  "aa_location_id": "3000005078",
  "city_name": "Shuyang",
  "ctrip_id": "21111"
}, {
  "aa_location_id": "6345067",
  "city_name": "Chengmai",
  "ctrip_id": "20836"
}, {
  "aa_location_id": "3000005084",
  "city_name": "Shucheng",
  "ctrip_id": "1082"
}, {
  "aa_location_id": "6342009",
  "city_name": "Longnan",
  "ctrip_id": "1108"
}, {
  "aa_location_id": "6342011",
  "city_name": "Gannan",
  "ctrip_id": "7844"
}, {
  "aa_location_id": "3000005581",
  "city_name": "Dingxi",
  "ctrip_id": "1021"
}, {
  "aa_location_id": "3000005114",
  "city_name": "Shengzhou",
  "ctrip_id": "1212"
}, {
  "aa_location_id": "3000005600",
  "city_name": "Dashiqiao",
  "ctrip_id": "967"
}, {
  "aa_location_id": "3000005605",
  "city_name": "Daocheng",
  "ctrip_id": "1222"
}, {
  "aa_location_id": "6338902",
  "city_name": "Liupanshui",
  "ctrip_id": "605"
}, {
  "aa_location_id": "3000005095",
  "city_name": "Shitai",
  "ctrip_id": "21409"
}, {
  "aa_location_id": "6338904",
  "city_name": "Jinchang",
  "ctrip_id": "1158"
}, {
  "aa_location_id": "3000005608",
  "city_name": "Dangchang",
  "ctrip_id": "20871"
}, {
  "aa_location_id": "6338905",
  "city_name": "Tongchuan",
  "ctrip_id": "118"
}, {
  "aa_location_id": "6339420",
  "city_name": "Danzhou",
  "ctrip_id": "57"
}, {
  "aa_location_id": "3000005529",
  "city_name": "Fenyang",
  "ctrip_id": "7604"
}, {
  "aa_location_id": "3000004996",
  "city_name": "Wudi",
  "ctrip_id": "3940"
}, {
  "aa_location_id": "3000005508",
  "city_name": "Gaomi",
  "ctrip_id": "1040"
}, {
  "aa_location_id": "6338365",
  "city_name": "Hechi",
  "ctrip_id": "3969"
}, {
  "aa_location_id": "3000005005",
  "city_name": "Wenling",
  "ctrip_id": "619"
}, {
  "aa_location_id": "3000005517",
  "city_name": "Gaizhou",
  "ctrip_id": "7569"
}, {
  "aa_location_id": "3000005026",
  "city_name": "Tunchang",
  "ctrip_id": "47"
}, {
  "aa_location_id": "3000005038",
  "city_name": "Tianchang",
  "ctrip_id": "7577"
}, {
  "aa_location_id": "3000005550",
  "city_name": "Duyun",
  "ctrip_id": "975"
}, {
  "aa_location_id": "3000004948",
  "city_name": "Xinchang",
  "ctrip_id": "872"
}, {
  "aa_location_id": "3000005471",
  "city_name": "Haiyan",
  "ctrip_id": "371"
}, {
  "aa_location_id": "3000004937",
  "city_name": "Xinghua",
  "ctrip_id": "7578"
}, {
  "aa_location_id": "3000004977",
  "city_name": "Xiangshui",
  "ctrip_id": "7695"
}, {
  "aa_location_id": "3000005496",
  "city_name": "Guangrao",
  "ctrip_id": "7625"
}, {
  "aa_location_id": "3000005500",
  "city_name": "Gongqingcheng",
  "ctrip_id": "21465"
}, {
  "aa_location_id": "3000005503",
  "city_name": "Gongcheng",
  "ctrip_id": "21304"
}, {
  "aa_location_id": "6339503",
  "city_name": "Lvliang",
  "ctrip_id": "7631"
}, {
  "aa_location_id": "3000004895",
  "city_name": "Yanggu",
  "ctrip_id": "20833"
}, {
  "aa_location_id": "3000004866",
  "city_name": "Yizheng",
  "ctrip_id": "1224"
}, {
  "aa_location_id": "3000004869",
  "city_name": "Yishui",
  "ctrip_id": "7630"
}, {
  "aa_location_id": "3000005383",
  "city_name": "Jiexiu",
  "ctrip_id": "135"
}, {
  "aa_location_id": "6345656",
  "city_name": "Bazhou",
  "ctrip_id": "1068"
}, {
  "aa_location_id": "6345657",
  "city_name": "Hainan",
  "ctrip_id": "7794"
}, {
  "aa_location_id": "3000004898",
  "city_name": "Yakeshi",
  "ctrip_id": "1136"
}, {
  "aa_location_id": "6326882",
  "city_name": "Shaowu",
  "ctrip_id": "448"
}, {
  "aa_location_id": "6280263",
  "city_name": "Rudong",
  "ctrip_id": "7557"
}, {
  "aa_location_id": "6267435",
  "city_name": "Xinyuan",
  "ctrip_id": "21551"
}, {
  "aa_location_id": "6273574",
  "city_name": "Suihua",
  "ctrip_id": "1128"
}, {
  "aa_location_id": "6325473",
  "city_name": "Haiyang",
  "ctrip_id": "1037"
}, {
  "aa_location_id": "6267106",
  "city_name": "Fangchenggang",
  "ctrip_id": "1677"
}, {
  "aa_location_id": "6280335",
  "city_name": "Jurong",
  "ctrip_id": "3230"
}, {
  "aa_location_id": "6275920",
  "city_name": "Cili",
  "ctrip_id": "1559"
}, {
  "aa_location_id": "6277399",
  "city_name": "Danyang",
  "ctrip_id": "238"
}, {
  "aa_location_id": "6308654",
  "city_name": "Bole",
  "ctrip_id": "2548"
}, {
  "aa_location_id": "6282034",
  "city_name": "Xianning",
  "ctrip_id": "937"
}, {
  "aa_location_id": "6277928",
  "city_name": "Siping",
  "ctrip_id": "440"
}, {
  "aa_location_id": "6277927",
  "city_name": "Wuzhou",
  "ctrip_id": "492"
}, {
  "aa_location_id": "6280150",
  "city_name": "Hai'an",
  "ctrip_id": "3923"
}, {
  "aa_location_id": "6280145",
  "city_name": "Dongtai",
  "ctrip_id": "3233"
}, {
  "aa_location_id": "6280132",
  "city_name": "Binhai",
  "ctrip_id": "20916"
}, {
  "aa_location_id": "6276545",
  "city_name": "Jiangshan",
  "ctrip_id": "1000"
}, {
  "aa_location_id": "6276490",
  "city_name": "Yunhe",
  "ctrip_id": "7789"
}, {
  "aa_location_id": "6256266",
  "city_name": "Qinzhou",
  "ctrip_id": "1899"
}, {
  "aa_location_id": "6256292",
  "city_name": "Xintian",
  "ctrip_id": "21817"
}, {
  "aa_location_id": "6250826",
  "city_name": "Suizhou",
  "ctrip_id": "1117"
}, {
  "aa_location_id": "6254456",
  "city_name": "Taishan",
  "ctrip_id": "729"
}, {
  "aa_location_id": "6233280",
  "city_name": "Shihezi",
  "ctrip_id": "426"
}, {
  "aa_location_id": "6231575",
  "city_name": "Fucheng",
  "ctrip_id": "21497"
}, {
  "aa_location_id": "6231610",
  "city_name": "Jingjiang",
  "ctrip_id": "3926"
}, {
  "aa_location_id": "6231595",
  "city_name": "Jiande",
  "ctrip_id": "658"
}, {
  "aa_location_id": "6226575",
  "city_name": "Deqin",
  "ctrip_id": "3928"
}, {
  "aa_location_id": "6231542",
  "city_name": "Shangcheng",
  "ctrip_id": "21813"
}, {
  "aa_location_id": "6219324",
  "city_name": "Luolong",
  "ctrip_id": "21363"
}, {
  "aa_location_id": "6219320",
  "city_name": "Mengjin",
  "ctrip_id": "2071"
}, {
  "aa_location_id": "6206687",
  "city_name": "Lianshan",
  "ctrip_id": "21569"
}, {
  "aa_location_id": "6196433",
  "city_name": "Shennongjia",
  "ctrip_id": "657"
}, {
  "aa_location_id": "6209225",
  "city_name": "Yingkou",
  "ctrip_id": "1300"
}, {
  "aa_location_id": "6209219",
  "city_name": "Yingtan",
  "ctrip_id": "534"
}, {
  "aa_location_id": "6218495",
  "city_name": "Kangding",
  "ctrip_id": "4130"
}, {
  "aa_location_id": "6218486",
  "city_name": "Libo",
  "ctrip_id": "1708"
}, {
  "aa_location_id": "6217972",
  "city_name": "Jinxiu",
  "ctrip_id": "21018"
}, {
  "aa_location_id": "6217970",
  "city_name": "Laibin",
  "ctrip_id": "1892"
}, {
  "aa_location_id": "6220010",
  "city_name": "Wuchang",
  "ctrip_id": "1582"
}, {
  "aa_location_id": "6217961",
  "city_name": "Longsheng",
  "ctrip_id": "7521"
}, {
  "aa_location_id": "6208669",
  "city_name": "Xinyang",
  "ctrip_id": "510"
}, {
  "aa_location_id": "6196409",
  "city_name": "Chibi",
  "ctrip_id": "1521"
}, {
  "aa_location_id": "6191798",
  "city_name": "Ziyang",
  "ctrip_id": "1560"
}, {
  "aa_location_id": "6208675",
  "city_name": "Fuxin",
  "ctrip_id": "254"
}, {
  "aa_location_id": "6196544",
  "city_name": "Anshun",
  "ctrip_id": "179"
}, {
  "aa_location_id": "6177560",
  "city_name": "Kunming",
  "ctrip_id": "34"
}, {
  "aa_location_id": "6218515",
  "city_name": "Mangshi",
  "ctrip_id": "3997"
}, {
  "aa_location_id": "6197510",
  "city_name": "Xinzhou",
  "ctrip_id": "513"
}, {
  "aa_location_id": "6197511",
  "city_name": "Shuozhou",
  "ctrip_id": "1317"
}, {
  "aa_location_id": "6196536",
  "city_name": "Chongzuo",
  "ctrip_id": "1896"
}, {
  "aa_location_id": "6218035",
  "city_name": "Qingyang",
  "ctrip_id": "404"
}, {
  "aa_location_id": "6196526",
  "city_name": "Ledong",
  "ctrip_id": "49"
}, {
  "aa_location_id": "6217003",
  "city_name": "Pingliang",
  "ctrip_id": "388"
}, {
  "aa_location_id": "6192424",
  "city_name": "Meishan",
  "ctrip_id": "1148"
}, {
  "aa_location_id": "6210512",
  "city_name": "Dengfeng",
  "ctrip_id": "222"
}, {
  "aa_location_id": "6210556",
  "city_name": "Yushan",
  "ctrip_id": "1001"
}, {
  "aa_location_id": "6197223",
  "city_name": "Ruoqiang",
  "ctrip_id": "21737"
}, {
  "aa_location_id": "6210528",
  "city_name": "Qidong",
  "ctrip_id": "697"
}, {
  "aa_location_id": "6218140",
  "city_name": "Rui'an",
  "ctrip_id": "408"
}, {
  "aa_location_id": "6197132",
  "city_name": "Guyuan",
  "ctrip_id": "321"
}, {
  "aa_location_id": "6219145",
  "city_name": "Yangquan",
  "ctrip_id": "907"
}, {
  "aa_location_id": "6218628",
  "city_name": "Neijiang",
  "ctrip_id": "1597"
}, {
  "aa_location_id": "6218624",
  "city_name": "Shangqiu",
  "ctrip_id": "441"
}, {
  "aa_location_id": "6219137",
  "city_name": "Ezhou",
  "ctrip_id": "992"
}, {
  "aa_location_id": "6207931",
  "city_name": "Changji",
  "ctrip_id": "7534"
}, {
  "aa_location_id": "6207926",
  "city_name": "Huludao",
  "ctrip_id": "1050"
}, {
  "aa_location_id": "6218158",
  "city_name": "Jishou",
  "ctrip_id": "1110"
}, {
  "aa_location_id": "6218154",
  "city_name": "Jingjiang",
  "ctrip_id": "3926"
}, {
  "aa_location_id": "6210985",
  "city_name": "Shizuishan",
  "ctrip_id": "4216"
}, {
  "aa_location_id": "6197153",
  "city_name": "Linxia",
  "ctrip_id": "3978"
}, {
  "aa_location_id": "6160478",
  "city_name": "Xingyi",
  "ctrip_id": "1139"
}, {
  "aa_location_id": "6155333",
  "city_name": "Weinan",
  "ctrip_id": "1030"
}, {
  "aa_location_id": "6155332",
  "city_name": "Baiyin",
  "ctrip_id": "1541"
}, {
  "aa_location_id": "6155334",
  "city_name": "Huayin",
  "ctrip_id": "119"
}, {
  "aa_location_id": "6155331",
  "city_name": "Chishui",
  "ctrip_id": "7544"
}, {
  "aa_location_id": "6156909",
  "city_name": "Pu'er",
  "ctrip_id": "3996"
}, {
  "aa_location_id": "6156908",
  "city_name": "Zhongwei",
  "ctrip_id": "556"
}, {
  "aa_location_id": "6156023",
  "city_name": "Huanggang",
  "ctrip_id": "3885"
}, {
  "aa_location_id": "6159522",
  "city_name": "Pingshan",
  "ctrip_id": "3924"
}, {
  "aa_location_id": "6140483",
  "city_name": "Shanwei",
  "ctrip_id": "1436"
}, {
  "aa_location_id": "6140482",
  "city_name": "Jieyang",
  "ctrip_id": "956"
}, {
  "aa_location_id": "6140535",
  "city_name": "Yunfu",
  "ctrip_id": "3933"
}, {
  "aa_location_id": "6141469",
  "city_name": "Ya'an",
  "ctrip_id": "3277"
}, {
  "aa_location_id": "6141470",
  "city_name": "Yulin",
  "ctrip_id": "527"
}, {
  "aa_location_id": "6141465",
  "city_name": "Turpan",
  "ctrip_id": "40"
}, {
  "aa_location_id": "6141467",
  "city_name": "Shangrao",
  "ctrip_id": "411"
}, {
  "aa_location_id": "6141466",
  "city_name": "Wuwei",
  "ctrip_id": "664"
}, {
  "aa_location_id": "6141460",
  "city_name": "Hulunbuir",
  "ctrip_id": "4255"
}, {
  "aa_location_id": "6141459",
  "city_name": "Hami",
  "ctrip_id": "285"
}, {
  "aa_location_id": "6140429",
  "city_name": "Jiuquan",
  "ctrip_id": "662"
}, {
  "aa_location_id": "6140462",
  "city_name": "Huangshi",
  "ctrip_id": "292"
}, {
  "aa_location_id": "6131928",
  "city_name": "Guangyuan",
  "ctrip_id": "267"
}, {
  "aa_location_id": "6134485",
  "city_name": "Binzhou",
  "ctrip_id": "1820"
}, {
  "aa_location_id": "6134483",
  "city_name": "Dezhou",
  "ctrip_id": "1370"
}, {
  "aa_location_id": "6131919",
  "city_name": "Dongying",
  "ctrip_id": "236"
}, {
  "aa_location_id": "6140608",
  "city_name": "Zhengzhou",
  "ctrip_id": "559"
}, {
  "aa_location_id": "6140610",
  "city_name": "Anyang",
  "ctrip_id": "181"
}, {
  "aa_location_id": "6140661",
  "city_name": "Shaoyang",
  "ctrip_id": "1111"
}, {
  "aa_location_id": "6140660",
  "city_name": "Loudi",
  "ctrip_id": "918"
}, {
  "aa_location_id": "6140663",
  "city_name": "Xiangxi",
  "ctrip_id": "3910"
}, {
  "aa_location_id": "6140662",
  "city_name": "Huaihua",
  "ctrip_id": "282"
}, {
  "aa_location_id": "6140659",
  "city_name": "Yongzhou",
  "ctrip_id": "970"
}, {
  "aa_location_id": "6131937",
  "city_name": "Wenshan",
  "ctrip_id": "1342"
}, {
  "aa_location_id": "6140575",
  "city_name": "Cangzhou",
  "ctrip_id": "216"
}, {
  "aa_location_id": "6140574",
  "city_name": "Zhangjiakou",
  "ctrip_id": "550"
}, {
  "aa_location_id": "6140569",
  "city_name": "Qinhuangdao",
  "ctrip_id": "147"
}, {
  "aa_location_id": "6140556",
  "city_name": "Qionghai",
  "ctrip_id": "52"
}, {
  "aa_location_id": "6140555",
  "city_name": "Wenchang",
  "ctrip_id": "44"
}, {
  "aa_location_id": "6130878",
  "city_name": "Panzhihua",
  "ctrip_id": "1097"
}, {
  "aa_location_id": "6130872",
  "city_name": "Dongshan",
  "ctrip_id": "2594"
}, {
  "aa_location_id": "6130870",
  "city_name": "Wanzai",
  "ctrip_id": "21123"
}, {
  "aa_location_id": "6149800",
  "city_name": "Mengla",
  "ctrip_id": "21208"
}, {
  "aa_location_id": "6140075",
  "city_name": "Xinmi",
  "ctrip_id": "4136"
}, {
  "aa_location_id": "6149799",
  "city_name": "Pingdingshan",
  "ctrip_id": "3222"
}, {
  "aa_location_id": "6149798",
  "city_name": "Zhumadian",
  "ctrip_id": "551"
}, {
  "aa_location_id": "6130849",
  "city_name": "Baoshan",
  "ctrip_id": "197"
}, {
  "aa_location_id": "6140244",
  "city_name": "Huaibei",
  "ctrip_id": "272"
}, {
  "aa_location_id": "6140241",
  "city_name": "Xuancheng",
  "ctrip_id": "1006"
}, {
  "aa_location_id": "6140240",
  "city_name": "Tongling",
  "ctrip_id": "459"
}, {
  "aa_location_id": "6140243",
  "city_name": "Huainan",
  "ctrip_id": "287"
}, {
  "aa_location_id": "6140239",
  "city_name": "Chizhou",
  "ctrip_id": "218"
}, {
  "aa_location_id": "6140778",
  "city_name": "Baishan",
  "ctrip_id": "3886"
}, {
  "aa_location_id": "6140775",
  "city_name": "Pingxiang",
  "ctrip_id": "396"
}, {
  "aa_location_id": "6140774",
  "city_name": "Xinyu",
  "ctrip_id": "603"
}, {
  "aa_location_id": "6140257",
  "city_name": "Tangshan",
  "ctrip_id": "468"
}, {
  "aa_location_id": "6131985",
  "city_name": "Shiyan",
  "ctrip_id": "452"
}, {
  "aa_location_id": "6140683",
  "city_name": "Bayan Nur",
  "ctrip_id": "3887"
}, {
  "aa_location_id": "6140682",
  "city_name": "Ordos",
  "ctrip_id": "3976"
}, {
  "aa_location_id": "6134068",
  "city_name": "Heze",
  "ctrip_id": "1074"
}, {
  "aa_location_id": "6134071",
  "city_name": "Liaocheng",
  "ctrip_id": "1071"
}, {
  "aa_location_id": "6140715",
  "city_name": "Yuxi",
  "ctrip_id": "186"
}, {
  "aa_location_id": "6143963",
  "city_name": "Zhoukou",
  "ctrip_id": "3221"
}, {
  "aa_location_id": "6143962",
  "city_name": "Luohe",
  "ctrip_id": "1088"
}, {
  "aa_location_id": "6141436",
  "city_name": "Qujing",
  "ctrip_id": "985"
}, {
  "aa_location_id": "6140909",
  "city_name": "Taizhou",
  "ctrip_id": "578"
}, {
  "aa_location_id": "6140819",
  "city_name": "Zaozhuang",
  "ctrip_id": "614"
}, {
  "aa_location_id": "6140349",
  "city_name": "Hezhou",
  "ctrip_id": "4146"
}, {
  "aa_location_id": "6140837",
  "city_name": "Jinzhong",
  "ctrip_id": "1453"
}, {
  "aa_location_id": "6140836",
  "city_name": "Baoting",
  "ctrip_id": "54"
}, {
  "aa_location_id": "6140323",
  "city_name": "Chongqing",
  "ctrip_id": "4"
}, {
  "aa_location_id": "6124889",
  "city_name": "Daqing",
  "ctrip_id": "231"
}, {
  "aa_location_id": "6124886",
  "city_name": "Yushu",
  "ctrip_id": "1610"
}, {
  "aa_location_id": "6124883",
  "city_name": "Yichun",
  "ctrip_id": "517"
}, {
  "aa_location_id": "6125395",
  "city_name": "Ma'anshan",
  "ctrip_id": "1024"
}, {
  "aa_location_id": "6124860",
  "city_name": "Jixi",
  "ctrip_id": "157"
}, {
  "aa_location_id": "6094872",
  "city_name": "Hengshui",
  "ctrip_id": "290"
}, {
  "aa_location_id": "6084656",
  "city_name": "Tianjin",
  "ctrip_id": "3"
}, {
  "aa_location_id": "6084854",
  "city_name": "Linfen",
  "ctrip_id": "139"
}, {
  "aa_location_id": "6085295",
  "city_name": "Lincang",
  "ctrip_id": "1236"
}, {
  "aa_location_id": "6095014",
  "city_name": "Benxi",
  "ctrip_id": "1155"
}, {
  "aa_location_id": "6084436",
  "city_name": "Nanjing",
  "ctrip_id": "12"
}, {
  "aa_location_id": "6084432",
  "city_name": "Putian",
  "ctrip_id": "667"
}, {
  "aa_location_id": "6084433",
  "city_name": "Sanming",
  "ctrip_id": "437"
}, {
  "aa_location_id": "6084974",
  "city_name": "Guilin",
  "ctrip_id": "33"
}, {
  "aa_location_id": "6084456",
  "city_name": "Suqian",
  "ctrip_id": "1472"
}, {
  "aa_location_id": "6084457",
  "city_name": "Hangzhou",
  "ctrip_id": "17"
}, {
  "aa_location_id": "6084455",
  "city_name": "Huai'an",
  "ctrip_id": "577"
}, {
  "aa_location_id": "6094792",
  "city_name": "Dali",
  "ctrip_id": "36"
}, {
  "aa_location_id": "6084491",
  "city_name": "Ningbo",
  "ctrip_id": "375"
}, {
  "aa_location_id": "6051944",
  "city_name": "Jincheng",
  "ctrip_id": "1092"
}, {
  "aa_location_id": "6069859",
  "city_name": "Sanya",
  "ctrip_id": "43"
}, {
  "aa_location_id": "6050845",
  "city_name": "Shangzhi",
  "ctrip_id": "2966"
}, {
  "aa_location_id": "6050312",
  "city_name": "Zunyi",
  "ctrip_id": "558"
}, {
  "aa_location_id": "6050309",
  "city_name": "Yongkang",
  "ctrip_id": "960"
}, {
  "aa_location_id": "6052353",
  "city_name": "Chuzhou",
  "ctrip_id": "214"
}, {
  "aa_location_id": "6050306",
  "city_name": "Wanning",
  "ctrip_id": "45"
}, {
  "aa_location_id": "6049998",
  "city_name": "Baoding",
  "ctrip_id": "185"
}, {
  "aa_location_id": "6050444",
  "city_name": "Jinzhong",
  "ctrip_id": "1453"
}, {
  "aa_location_id": "6050446",
  "city_name": "Xuchang",
  "ctrip_id": "1094"
}, {
  "aa_location_id": "6049423",
  "city_name": "Bozhou",
  "ctrip_id": "1078"
}, {
  "aa_location_id": "6060676",
  "city_name": "Suzhou",
  "ctrip_id": "14"
}, {
  "aa_location_id": "6064259",
  "city_name": "Guangzhou",
  "ctrip_id": "32"
}, {
  "aa_location_id": "6069945",
  "city_name": "Qingtian",
  "ctrip_id": "961"
}, {
  "aa_location_id": "6069940",
  "city_name": "Ji'an",
  "ctrip_id": "161"
}, {
  "aa_location_id": "6056285",
  "city_name": "Wuhai",
  "ctrip_id": "1133"
}, {
  "aa_location_id": "6050133",
  "city_name": "Lingao",
  "ctrip_id": "20868"
}, {
  "aa_location_id": "6050128",
  "city_name": "Meizhou",
  "ctrip_id": "3053"
}, {
  "aa_location_id": "6050129",
  "city_name": "Deqing",
  "ctrip_id": "1367"
}, {
  "aa_location_id": "6051665",
  "city_name": "Yuncheng",
  "ctrip_id": "140"
}, {
  "aa_location_id": "6050130",
  "city_name": "Zibo",
  "ctrip_id": "542"
}, {
  "aa_location_id": "6050124",
  "city_name": "Zigong",
  "ctrip_id": "544"
}, {
  "aa_location_id": "6050126",
  "city_name": "Tieling",
  "ctrip_id": "1048"
}, {
  "aa_location_id": "6050127",
  "city_name": "Yichun",
  "ctrip_id": "517"
}, {
  "aa_location_id": "6050121",
  "city_name": "Sanmenxia",
  "ctrip_id": "436"
}, {
  "aa_location_id": "6052216",
  "city_name": "Tianshui",
  "ctrip_id": "464"
}, {
  "aa_location_id": "6049652",
  "city_name": "Chaozhou",
  "ctrip_id": "215"
}, {
  "aa_location_id": "6051680",
  "city_name": "Chaohu",
  "ctrip_id": "589"
}, {
  "aa_location_id": "6050072",
  "city_name": "Jiangmen",
  "ctrip_id": "316"
}, {
  "aa_location_id": "6050068",
  "city_name": "Hegang",
  "ctrip_id": "1611"
}, {
  "aa_location_id": "6050069",
  "city_name": "Hebi",
  "ctrip_id": "951"
}, {
  "aa_location_id": "6060309",
  "city_name": "Jiaozuo",
  "ctrip_id": "1093"
}, {
  "aa_location_id": "6050071",
  "city_name": "Kaifeng",
  "ctrip_id": "331"
}, {
  "aa_location_id": "6060304",
  "city_name": "Yueyang",
  "ctrip_id": "539"
}, {
  "aa_location_id": "6060306",
  "city_name": "Golmud",
  "ctrip_id": "132"
}, {
  "aa_location_id": "6050060",
  "city_name": "Langfang",
  "ctrip_id": "340"
}, {
  "aa_location_id": "6050058",
  "city_name": "Heyuan",
  "ctrip_id": "693"
}, {
  "aa_location_id": "6050059",
  "city_name": "Handan",
  "ctrip_id": "275"
}, {
  "aa_location_id": "6050054",
  "city_name": "Deyang",
  "ctrip_id": "237"
}, {
  "aa_location_id": "6084415",
  "city_name": "Nanping",
  "ctrip_id": "606"
}, {
  "aa_location_id": "6050093",
  "city_name": "Qingyuan",
  "ctrip_id": "1150"
}, {
  "aa_location_id": "6052142",
  "city_name": "Chenzhou",
  "ctrip_id": "612"
}, {
  "aa_location_id": "6050089",
  "city_name": "Maoming",
  "ctrip_id": "1105"
}, {
  "aa_location_id": "6050090",
  "city_name": "Panjin",
  "ctrip_id": "387"
}, {
  "aa_location_id": "6050091",
  "city_name": "Pinghu",
  "ctrip_id": "1206"
}, {
  "aa_location_id": "6084395",
  "city_name": "Xiamen",
  "ctrip_id": "25"
}, {
  "aa_location_id": "6050084",
  "city_name": "Jinzhou",
  "ctrip_id": "327"
}, {
  "aa_location_id": "6050086",
  "city_name": "Leshan",
  "ctrip_id": "345"
}, {
  "aa_location_id": "6050087",
  "city_name": "Longyan",
  "ctrip_id": "348"
}, {
  "aa_location_id": "6050080",
  "city_name": "Liyang",
  "ctrip_id": "1358"
}, {
  "aa_location_id": "6050083",
  "city_name": "Jingmen",
  "ctrip_id": "1121"
}, {
  "aa_location_id": "6069705",
  "city_name": "Jiangmen",
  "ctrip_id": "316"
}, {
  "aa_location_id": "6069706",
  "city_name": "Huizhou",
  "ctrip_id": "299"
}, {
  "aa_location_id": "6069701",
  "city_name": "Foshan",
  "ctrip_id": "251"
}, {
  "aa_location_id": "6069699",
  "city_name": "Fenggang",
  "ctrip_id": "21105"
}, {
  "aa_location_id": "6049776",
  "city_name": "Zhangye",
  "ctrip_id": "663"
}, {
  "aa_location_id": "6050289",
  "city_name": "Yangjiang",
  "ctrip_id": "692"
}, {
  "aa_location_id": "6049772",
  "city_name": "Rizhao",
  "ctrip_id": "1106"
}, {
  "aa_location_id": "6050286",
  "city_name": "Xinxiang",
  "ctrip_id": "507"
}, {
  "aa_location_id": "6049775",
  "city_name": "Wuzhishan",
  "ctrip_id": "46"
}, {
  "aa_location_id": "6049771",
  "city_name": "Puyang",
  "ctrip_id": "1232"
}, {
  "aa_location_id": "6049763",
  "city_name": "Dongyang",
  "ctrip_id": "755"
}, {
  "aa_location_id": "6049686",
  "city_name": "Yangzhou",
  "ctrip_id": "15"
}, {
  "aa_location_id": "6049677",
  "city_name": "Ningde",
  "ctrip_id": "378"
}, {
  "aa_location_id": "6055311",
  "city_name": "Baoji",
  "ctrip_id": "112"
}, {
  "aa_location_id": "6049673",
  "city_name": "Lingshui",
  "ctrip_id": "55"
}, {
  "aa_location_id": "6049674",
  "city_name": "Lishui",
  "ctrip_id": "346"
}, {
  "aa_location_id": "6049670",
  "city_name": "Huzhou",
  "ctrip_id": "86"
}, {
  "aa_location_id": "6049671",
  "city_name": "Lanxi",
  "ctrip_id": "597"
}, {
  "aa_location_id": "6049726",
  "city_name": "Linyi",
  "ctrip_id": "569"
}, {
  "aa_location_id": "6049727",
  "city_name": "Zhangzhou",
  "ctrip_id": "560"
}, {
  "aa_location_id": "6069689",
  "city_name": "Dongguan",
  "ctrip_id": "223"
}, {
  "aa_location_id": "6055856",
  "city_name": "Yiyang",
  "ctrip_id": "1002"
}, {
  "aa_location_id": "6035039",
  "city_name": "Dali",
  "ctrip_id": "36"
}, {
  "aa_location_id": "6046792",
  "city_name": "Shenzhen",
  "ctrip_id": "30"
}, {
  "aa_location_id": "6047818",
  "city_name": "Huangshan",
  "ctrip_id": "23"
}, {
  "aa_location_id": "6047299",
  "city_name": "Taizhou",
  "ctrip_id": "578"
}, {
  "aa_location_id": "6034556",
  "city_name": "Jingzhou",
  "ctrip_id": "328"
}, {
  "aa_location_id": "6034536",
  "city_name": "Suining",
  "ctrip_id": "1371"
}, {
  "aa_location_id": "6047255",
  "city_name": "Jiuzhaigou",
  "ctrip_id": "91"
}, {
  "aa_location_id": "6047744",
  "city_name": "Tiantai",
  "ctrip_id": "470"
}, {
  "aa_location_id": "6034480",
  "city_name": "Zhongshan",
  "ctrip_id": "553"
}, {
  "aa_location_id": "6047967",
  "city_name": "Kangping",
  "ctrip_id": "20979"
}, {
  "aa_location_id": "6047448",
  "city_name": "Lijiang",
  "ctrip_id": "37"
}, {
  "aa_location_id": "6035144",
  "city_name": "Jiaozhou",
  "ctrip_id": "1043"
}, {
  "aa_location_id": "6047970",
  "city_name": "Zhuzhou",
  "ctrip_id": "601"
}, {
  "aa_location_id": "6048917",
  "city_name": "Chengde",
  "ctrip_id": "562"
}, {
  "aa_location_id": "181011",
  "city_name": "Wuchang",
  "ctrip_id": "1582"
}, {
  "aa_location_id": "181009",
  "city_name": "Dongguan",
  "ctrip_id": "223"
}, {
  "aa_location_id": "181040",
  "city_name": "Tangshan",
  "ctrip_id": "468"
}, {
  "aa_location_id": "180026",
  "city_name": "Shanghai",
  "ctrip_id": "2"
}, {
  "aa_location_id": "6035298",
  "city_name": "Foshan",
  "ctrip_id": "251"
}, {
  "aa_location_id": "6048027",
  "city_name": "Zhoushan",
  "ctrip_id": "19"
}, {
  "aa_location_id": "6048021",
  "city_name": "Zhaoqing",
  "ctrip_id": "552"
}, {
  "aa_location_id": "6046980",
  "city_name": "Shaoxing",
  "ctrip_id": "22"
}, {
  "aa_location_id": "6047542",
  "city_name": "Jiaxing",
  "ctrip_id": "571"
}, {
  "aa_location_id": "6046674",
  "city_name": "Shangri-La",
  "ctrip_id": "660"
}, {
  "aa_location_id": "181139",
  "city_name": "Mianyang",
  "ctrip_id": "370"
}, {
  "aa_location_id": "6047743",
  "city_name": "Zhenjiang",
  "ctrip_id": "16"
}, {
  "aa_location_id": "6047718",
  "city_name": "Yicheng",
  "ctrip_id": "21245"
}, {
  "aa_location_id": "6025609",
  "city_name": "Wulian",
  "ctrip_id": "7700"
}, {
  "aa_location_id": "6047160",
  "city_name": "Zhangjiajie",
  "ctrip_id": "27"
}, {
  "aa_location_id": "6047668",
  "city_name": "Jinhua",
  "ctrip_id": "308"
}, {
  "aa_location_id": "1537",
  "city_name": "Huizhou",
  "ctrip_id": "299"
}, {
  "aa_location_id": "7169",
  "city_name": "Quanzhou",
  "ctrip_id": "406"
}, {
  "aa_location_id": "1026",
  "city_name": "Dalian",
  "ctrip_id": "6"
}, {
  "aa_location_id": "771",
  "city_name": "Guangzhou",
  "ctrip_id": "32"
}, {
  "aa_location_id": "3592",
  "city_name": "Taiyuan",
  "ctrip_id": "105"
}, {
  "aa_location_id": "3851",
  "city_name": "Xiangyang",
  "ctrip_id": "496"
}, {
  "aa_location_id": "1550",
  "city_name": "Hanzhong",
  "ctrip_id": "129"
}, {
  "aa_location_id": "1807",
  "city_name": "Kashgar",
  "ctrip_id": "109"
}, {
  "aa_location_id": "3855",
  "city_name": "Xichang",
  "ctrip_id": "494"
}, {
  "aa_location_id": "3346",
  "city_name": "Sanya",
  "ctrip_id": "43"
}, {
  "aa_location_id": "1811",
  "city_name": "Nanchang",
  "ctrip_id": "376"
}, {
  "aa_location_id": "2580",
  "city_name": "Nanning",
  "ctrip_id": "380"
}, {
  "aa_location_id": "2070",
  "city_name": "Laohekou",
  "ctrip_id": "2155"
}, {
  "aa_location_id": "2071",
  "city_name": "Lanzhou",
  "ctrip_id": "100"
}, {
  "aa_location_id": "3863",
  "city_name": "Xiamen",
  "ctrip_id": "25"
}, {
  "aa_location_id": "7703",
  "city_name": "Ulanhot",
  "ctrip_id": "484"
}, {
  "aa_location_id": "2584",
  "city_name": "Nanyang",
  "ctrip_id": "385"
}, {
  "aa_location_id": "3353",
  "city_name": "Suzhou",
  "ctrip_id": "14"
}, {
  "aa_location_id": "3865",
  "city_name": "Xining",
  "ctrip_id": "124"
}, {
  "aa_location_id": "3354",
  "city_name": "Shenzhen",
  "ctrip_id": "30"
}, {
  "aa_location_id": "3866",
  "city_name": "Xingtai",
  "ctrip_id": "947"
}, {
  "aa_location_id": "3876",
  "city_name": "Xuzhou",
  "ctrip_id": "512"
}, {
  "aa_location_id": "550",
  "city_name": "Bengbu",
  "ctrip_id": "182"
}, {
  "aa_location_id": "3366",
  "city_name": "Qingdao",
  "ctrip_id": "7"
}, {
  "aa_location_id": "7720",
  "city_name": "Hengyang",
  "ctrip_id": "297"
}, {
  "aa_location_id": "2604",
  "city_name": "Nantong",
  "ctrip_id": "82"
}, {
  "aa_location_id": "822",
  "city_name": "Zhengzhou",
  "ctrip_id": "559"
}, {
  "aa_location_id": "824",
  "city_name": "Changchun",
  "ctrip_id": "158"
}, {
  "aa_location_id": "3900",
  "city_name": "Yibin",
  "ctrip_id": "514"
}, {
  "aa_location_id": "1597",
  "city_name": "Yinchuan",
  "ctrip_id": "99"
}, {
  "aa_location_id": "7741",
  "city_name": "Shaoguan",
  "ctrip_id": "422"
}, {
  "aa_location_id": "1855",
  "city_name": "Kunming",
  "ctrip_id": "34"
}, {
  "aa_location_id": "3647",
  "city_name": "Urumqi",
  "ctrip_id": "39"
}, {
  "aa_location_id": "4159",
  "city_name": "Zhaotong",
  "ctrip_id": "555"
}, {
  "aa_location_id": "178237",
  "city_name": "Beijing",
  "ctrip_id": "1"
}, {
  "aa_location_id": "576",
  "city_name": "Beihai",
  "ctrip_id": "189"
}, {
  "aa_location_id": "10050",
  "city_name": "Tongliao",
  "ctrip_id": "458"
}, {
  "aa_location_id": "3145",
  "city_name": "Shanghai",
  "ctrip_id": "2"
}, {
  "aa_location_id": "3149",
  "city_name": "Shenyang",
  "ctrip_id": "451"
}, {
  "aa_location_id": "4174",
  "city_name": "Zhanjiang",
  "ctrip_id": "547"
}, {
  "aa_location_id": "597",
  "city_name": "Beijing",
  "ctrip_id": "1"
}, {
  "aa_location_id": "853",
  "city_name": "Chongqing",
  "ctrip_id": "4"
}, {
  "aa_location_id": "1622",
  "city_name": "Qiemo",
  "ctrip_id": "399"
}, {
  "aa_location_id": "3672",
  "city_name": "Yulin",
  "ctrip_id": "527"
}, {
  "aa_location_id": "3163",
  "city_name": "Xi'an",
  "ctrip_id": "10"
}, {
  "aa_location_id": "1890",
  "city_name": "Ganzhou",
  "ctrip_id": "268"
}, {
  "aa_location_id": "3180",
  "city_name": "Shijiazhuang",
  "ctrip_id": "428"
}, {
  "aa_location_id": "2160",
  "city_name": "Luxi",
  "ctrip_id": "7682"
}, {
  "aa_location_id": "1909",
  "city_name": "Korla",
  "ctrip_id": "330"
}, {
  "aa_location_id": "1917",
  "city_name": "Karamay",
  "ctrip_id": "166"
}, {
  "aa_location_id": "1151",
  "city_name": "Yan'an",
  "ctrip_id": "110"
}, {
  "aa_location_id": "2179",
  "city_name": "Lhasa",
  "ctrip_id": "41"
}, {
  "aa_location_id": "3972",
  "city_name": "Yichang",
  "ctrip_id": "515"
}, {
  "aa_location_id": "9861",
  "city_name": "Qinhuangdao",
  "ctrip_id": "147"
}, {
  "aa_location_id": "3974",
  "city_name": "Yining",
  "ctrip_id": "529"
}, {
  "aa_location_id": "8070",
  "city_name": "Jingdezhen",
  "ctrip_id": "305"
}, {
  "aa_location_id": "2183",
  "city_name": "Luoyang",
  "ctrip_id": "350"
}, {
  "aa_location_id": "393",
  "city_name": "Anshan",
  "ctrip_id": "178"
}, {
  "aa_location_id": "2186",
  "city_name": "Lianyungang",
  "ctrip_id": "353"
}, {
  "aa_location_id": "2193",
  "city_name": "Liuzhou",
  "ctrip_id": "354"
}, {
  "aa_location_id": "1426",
  "city_name": "Haikou",
  "ctrip_id": "42"
}, {
  "aa_location_id": "2194",
  "city_name": "Luzhou",
  "ctrip_id": "355"
}, {
  "aa_location_id": "1686",
  "city_name": "Jiayuguan",
  "ctrip_id": "326"
}, {
  "aa_location_id": "177812",
  "city_name": "Xianyang",
  "ctrip_id": "111"
}, {
  "aa_location_id": "407",
  "city_name": "Anqing",
  "ctrip_id": "177"
}, {
  "aa_location_id": "922",
  "city_name": "Changsha",
  "ctrip_id": "206"
}, {
  "aa_location_id": "7324",
  "city_name": "Fuyang",
  "ctrip_id": "257"
}, {
  "aa_location_id": "1696",
  "city_name": "Jilin",
  "ctrip_id": "159"
}, {
  "aa_location_id": "930",
  "city_name": "Chengdu",
  "ctrip_id": "28"
}, {
  "aa_location_id": "1698",
  "city_name": "Jiujiang",
  "ctrip_id": "24"
}, {
  "aa_location_id": "3491",
  "city_name": "Jinan",
  "ctrip_id": "144"
}, {
  "aa_location_id": "1445",
  "city_name": "Hohhot",
  "ctrip_id": "103"
}, {
  "aa_location_id": "1448",
  "city_name": "Hefei",
  "ctrip_id": "278"
}, {
  "aa_location_id": "3496",
  "city_name": "Tonghua",
  "ctrip_id": "456"
}, {
  "aa_location_id": "1710",
  "city_name": "Jiamusi",
  "ctrip_id": "317"
}, {
  "aa_location_id": "4014",
  "city_name": "Yanji",
  "ctrip_id": "523"
}, {
  "aa_location_id": "1967",
  "city_name": "Guiyang",
  "ctrip_id": "38"
}, {
  "aa_location_id": "1712",
  "city_name": "Jining",
  "ctrip_id": "318"
}, {
  "aa_location_id": "4018",
  "city_name": "Yantai",
  "ctrip_id": "533"
}, {
  "aa_location_id": "1459",
  "city_name": "Huanghua",
  "ctrip_id": "7644"
}, {
  "aa_location_id": "4019",
  "city_name": "Yancheng",
  "ctrip_id": "1200"
}, {
  "aa_location_id": "3774",
  "city_name": "Weifang",
  "ctrip_id": "475"
}, {
  "aa_location_id": "3775",
  "city_name": "Weihai",
  "ctrip_id": "479"
}, {
  "aa_location_id": "10687",
  "city_name": "Zhuhai",
  "ctrip_id": "31"
}, {
  "aa_location_id": "7363",
  "city_name": "Xiangtan",
  "ctrip_id": "598"
}, {
  "aa_location_id": "2247",
  "city_name": "Mudanjiang",
  "ctrip_id": "150"
}, {
  "aa_location_id": "3786",
  "city_name": "Wuhu",
  "ctrip_id": "478"
}, {
  "aa_location_id": "971",
  "city_name": "Changzhou",
  "ctrip_id": "213"
}, {
  "aa_location_id": "1743",
  "city_name": "Quzhou",
  "ctrip_id": "407"
}, {
  "aa_location_id": "6607",
  "city_name": "Changde",
  "ctrip_id": "201"
}, {
  "aa_location_id": "6097",
  "city_name": "Ankang",
  "ctrip_id": "171"
}, {
  "aa_location_id": "979",
  "city_name": "Datong",
  "ctrip_id": "136"
}, {
  "aa_location_id": "2516",
  "city_name": "Nanchong",
  "ctrip_id": "377"
}, {
  "aa_location_id": "1239",
  "city_name": "Fuzhou",
  "ctrip_id": "258"
}, {
  "aa_location_id": "6616",
  "city_name": "Chaoyang",
  "ctrip_id": "211"
}, {
  "aa_location_id": "10456",
  "city_name": "Wuxi",
  "ctrip_id": "13"
}, {
  "aa_location_id": "3545",
  "city_name": "Tianjin",
  "ctrip_id": "3"
}, {
  "aa_location_id": "6621",
  "city_name": "Chifeng",
  "ctrip_id": "202"
}, {
  "aa_location_id": "990",
  "city_name": "Dandong",
  "ctrip_id": "221"
}, {
  "aa_location_id": "6623",
  "city_name": "Changzhi",
  "ctrip_id": "137"
}, {
  "aa_location_id": "1510",
  "city_name": "Harbin",
  "ctrip_id": "5"
}, {
  "aa_location_id": "3814",
  "city_name": "Wenzhou",
  "ctrip_id": "491"
}, {
  "aa_location_id": "1768",
  "city_name": "Kuqa",
  "ctrip_id": "329"
}, {
  "aa_location_id": "2537",
  "city_name": "Qiqihar",
  "ctrip_id": "149"
}, {
  "aa_location_id": "3050",
  "city_name": "Rugao",
  "ctrip_id": "4139"
}, {
  "aa_location_id": "496",
  "city_name": "Baotou",
  "ctrip_id": "141"
}, {
  "aa_location_id": "1267",
  "city_name": "Fushun",
  "ctrip_id": "252"
}, {
  "aa_location_id": "1523",
  "city_name": "Hotan",
  "ctrip_id": "294"
}, {
  "aa_location_id": "1269",
  "city_name": "Fuyun",
  "ctrip_id": "255"
}, {
  "aa_location_id": "3317",
  "city_name": "Shantou",
  "ctrip_id": "447"
}, {
  "aa_location_id": "3835",
  "city_name": "Wuhan",
  "ctrip_id": "477"
}];
var _default = ctripCityMaping;
exports["default"] = _default;